<template>
    <v-flex xs12 sm12 d-block class="card-dados">
        <h3 class="card-dados__titulo mb-0">Alterações Após Publicação</h3>
        <v-timeline align-top dense class="mx-3">
            <v-timeline-item v-for="evento in eventos" :key="evento.id"
                             :icon="selecionarIcone(evento)"
                             icon-color="#777777"
                             color="#EBEBEB"
                             fill-dot small>
                <v-layout>
                    <v-flex class="conteudo-evento az-text pl-0 mt-2">
                        <div>
                            <strong>{{selecionarTituloEvento(evento)}}</strong>
                            <span>
                                - {{evento.dataCadastro | az-date(humanizarFormatoDataHora(evento.dataHoraAnterior))}}
                            </span>
                        </div>
                        <div v-if="evento.tipo === 'PRORROGACAO'">
                            <strong>Data Antiga: </strong>
                            {{evento.dataHoraAnterior | az-date(humanizarFormatoDataHora(evento.dataHoraAnterior))}}
                            <span>|</span>
                            <strong>Data Nova: </strong>
                            {{evento.dataHoraAtualizada | az-date(humanizarFormatoDataHora(evento.dataHoraAnterior))}}
                        </div>
                        <strong>Motivo: </strong> {{evento.motivo}}
                    </v-flex>
                </v-layout>
            </v-timeline-item>
        </v-timeline>
    </v-flex>
</template>
<script>
export default {
    name: 'TimelineEventosPosPublicacao',
    props:{
        eventos:{
            type: Array,
            default: null
        }
    },
    methods:{
        selecionarIcone(evento){
            if(evento.tipo === 'PRORROGACAO')
                return 'far fa-clock'
            if(evento.tipo === 'DESPUBLICACAO')
                return 'fas fa-ban'
            return null
        },
        selecionarTituloEvento(evento){
            if(evento.tipo === 'PRORROGACAO')
                return 'Compra Prorrogada'
            if(evento.tipo === 'DESPUBLICACAO')
                return 'Compra Despublicada'
            return null
        }
    }
}
</script>

<style lang="stylus">
    .conteudo-evento
        color #888888
        strong
            color #777777
</style>
